import { mapActions, mapState } from 'vuex';

export default {
  props: {
    tab: {
      type: String,
      required: true,
    },
    limit: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    ...mapState('search', { tabs: 'tabs', query: 'query', isGlobalLoading: 'isLoading' }),

    results() {
      return this.tabs[this.tab].total;
    },

    hasResults() {
      return this.results > 0;
    },

    hasLimit() {
      return this.limit > 0;
    },

    displayLoadMore() {
      return this.limit === 0 && !this.tabs[this.tab].dataFullyLoaded;
    },

    displayedResultsCount() {
      return this.tabs[this.tab]?.data.length ?? 0;
    },

    isLoading() {
      return this.tabs[this.tab].isLoading;
    },
  },

  methods: {
    ...mapActions('search', ['changeCurrentTab', 'loadData']),

    onViewAllClick() {
      this.changeCurrentTab(this.tab);
    },

    onLoadMoreClick() {
      this.loadData({ clearData: false, tab: this.tab });
    },
  },
};
